export enum CompBucket {
  OTH = "OTH", //Others
  BAL = "BAL", //Bharti Airtel Limited
}

export const CompBucketList = Object.values(CompBucket);
